import { MagicFilled } from "@aircall/icons";
import { Flex, Typography } from "@aircall/tractor";
import { Count, Tab } from "@dashboard/library";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import { TAB_WITH_ICON } from "./TabMenu.constants";
import { TabMenuProps } from "./TabMenu.decl";
import { useHandlers, useRedirect } from "./TabMenu.hooks";
import { StyledTabContainer, StyledTabMenuItem } from "./TabMenu.styled";
import { pickActiveTab } from "./TabMenu.utilities";

import { useGetTagsAndNotes } from "@/hooks/useGetTagsAndNotes/useGetTagsAndNotes";
import { usePathParams } from "@/states/path_param";

export function TabMenu({ tabs, disabledTabs }: TabMenuProps) {
  const { t } = useTranslation();
  const location = useLocation();

  const { callId } = usePathParams();

  const { notes } = useGetTagsAndNotes({ callId });

  const { onChangeTab: handleOnChangeTab } = useHandlers();

  useRedirect({ disabledTabs });

  return (
    <StyledTabContainer
      onChange={handleOnChangeTab}
      activeTabId={pickActiveTab({
        pathname: location.pathname ?? "",
        tabs,
        disabledTabs,
      })}
    >
      <Tab.Menu>
        {tabs.map((tab) => {
          switch (tab) {
            case "notes":
              return (
                <Tab.MenuItem id="notes" key="notes">
                  <Flex gap="xxs" alignItems="center">
                    <Typography variant="bodyMediumM">
                      {t("menu_tabs.notes")}
                    </Typography>
                    {notes?.length > 0 && <Count value={notes.length} />}
                  </Flex>
                </Tab.MenuItem>
              );

            case "info":
              return (
                <Tab.MenuItem id="info" key="info">
                  <Flex gap="xxs" alignItems="center">
                    <Typography variant="bodyMediumM">
                      {t("menu_tabs.info")}
                    </Typography>
                  </Flex>
                </Tab.MenuItem>
              );

            default:
              return (
                <StyledTabMenuItem
                  key={tab}
                  id={tab}
                  disabled={disabledTabs.includes(tab)}
                >
                  <Flex alignItems="center" gap="xxs">
                    <Typography variant="bodyMediumM">
                      {t(`menu_tabs.${tab}`)}
                    </Typography>
                    {TAB_WITH_ICON.includes(tab) && <MagicFilled size={18} />}
                  </Flex>
                </StyledTabMenuItem>
              );
          }
        })}
      </Tab.Menu>
    </StyledTabContainer>
  );
}
